/* globals Handlebars, global */
export const conditionalHelpers = {
  eq: function (v1, v2) {
    return v1 === v2;
  },
  ne: function (v1, v2) {
    return v1 !== v2;
  },
  neq: function (v1, v2) {
    return v1 !== v2;
  },
  lt: function (v1, v2) {
    return v1 < v2;
  },
  gt: function (v1, v2) {
    return v1 > v2;
  },
  lte: function (v1, v2) {
    return v1 <= v2;
  },
  gte: function (v1, v2) {
    return v1 >= v2;
  },
  and: function (v1, v2) {
    return v1 && v2;
  },
  or: function (v1, v2) {
    return v1 || v2;
  },
  isNull: function (v1) {
    return v1 == null;
  },
  isNotNull: function (v1) {
    return v1 != null;
  },
  not: function (v1) {
    return !v1;
  },
  ternary: function (v1, v2, v3) {
    return v1 ? v2 : v3;
  }
};

if (global.Handlebars) {
  Handlebars.registerHelper(conditionalHelpers);
}

export default function(Handlebars) {
  Handlebars.registerHelper(conditionalHelpers);
}